var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-nav',_vm._l((_vm.inactiveLanguages),function(lang,index){return _c('b-nav-item',{key:index,on:{"click":function($event){return _vm.updateActiveLanguage(lang)}}},[_vm._v(" "+_vm._s(_vm._f("uppercase")(lang))+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }